import { ProgressState } from '../pages/dashboard/fsbo';

interface ChecklistExportOptions {
  progress: ProgressState;
  allItems: Array<{ id: string; title: string; required?: boolean }>;
  isSellerReady: boolean;
  isBuyerReady: boolean;
  progressPercent: number;
}

export function openChecklistPrintWindow({
  progress,
  allItems,
  isSellerReady,
  isBuyerReady,
  progressPercent
}: ChecklistExportOptions) {
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;

  const today = new Date().toLocaleDateString('en-IE');

  const checklistRows = allItems
    .map(
      (item) =>
        `<tr>
          <td style="padding: 8px 12px; border: 1px solid #e2e8f0;">${item.title}</td>
          <td style="padding: 8px 12px; border: 1px solid #e2e8f0; text-align:center;">
            ${progress[item.id as keyof ProgressState] ? '✔️ Complete' : '⏳ Outstanding'}
          </td>
          <td style="padding: 8px 12px; border: 1px solid #e2e8f0; text-align:center;">
            ${item.required ? 'Yes' : 'No'}
          </td>
        </tr>`
    )
    .join('');

  const printContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>FSBO Property Sale Checklist</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            color: #333;
            max-width: 900px;
            margin: 0 auto;
            padding: 24px;
          }
          .header {
            text-align: center;
            margin-bottom: 30px;
            border-bottom: 2px solid #2563eb;
            padding-bottom: 20px;
          }
          .summary {
            margin: 24px 0 32px 0;
            font-size: 16px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 32px;
          }
          th, td {
            font-size: 15px;
          }
          th {
            background: #f1f5f9;
            color: #2563eb;
            font-weight: bold;
            padding: 10px 12px;
            border: 1px solid #e2e8f0;
          }
          .footer {
            margin-top: 30px;
            text-align: center;
            font-size: 12px;
            color: #64748b;
            border-top: 1px solid #e2e8f0;
            padding-top: 20px;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>FSBO Property Sale Checklist</h1>
          <p>Generated from RentSmart.ie on ${today}</p>
        </div>
        <div class="summary">
          <strong>Seller Ready:</strong> ${isSellerReady ? 'Yes' : 'No'}<br/>
          <strong>Buyer Ready:</strong> ${isBuyerReady ? 'Yes' : 'No'}<br/>
          <strong>Progress:</strong> ${progressPercent}%
        </div>
        <table>
          <thead>
            <tr>
              <th>Checklist Item</th>
              <th>Status</th>
              <th>Required</th>
            </tr>
          </thead>
          <tbody>
            ${checklistRows}
          </tbody>
        </table>
        <div class="footer">
          <p>For more information, visit: ${window.location.origin}/seller-checklist</p>
        </div>
      </body>
    </html>
  `;

  printWindow.document.write(printContent);
  printWindow.document.close();
  printWindow.onload = () => {
    printWindow.print();
  };
}
